export default __webpack_public_path__ + "static/media/circled-play-icon.b979b516.svg";